export { default as TermsSection } from './TermsSection';